import { LoggerConfig } from './core/logger/logger-config';
import { LogLevel } from './core/logger/log-level';
import { ConsolePublisher } from './core/logger/console-publisher';
import { HttpConfig, Path } from "./core/http/http-config";
import { AuthConfig } from './core/auth/auth-config';
import { StorageConfig } from './core/storage/storage-config';

export const LOGGER_CONFIG: LoggerConfig = {
    logLevel: LogLevel.DEBUG,
    publishers: [ConsolePublisher]
  };

export const API_NAME_DEFAULT = 'realtorCentral';

let devActive = false;

export const HTTP_CONFIG: HttpConfig = {
  apiName:    API_NAME_DEFAULT,
  apiUrl:     devActive? 'https://kvmct7n4n2.execute-api.sa-east-1.amazonaws.com/' : 'https://3wtx07ztlc.execute-api.sa-east-1.amazonaws.com/',
  apiStage:   devActive? 'dev201203/': 'w1121/',
  apiKey:     devActive? 'saiTsGOYVU3yjwfsMIA2398S7ivaM7a298GcmpGO' : 'tjMd95SezsaIU5bvkWymz7hn5Y35YWpq9MRoLtr7',
  region:    'sa-east-1' 
};

export const AUTH_CONFIG: AuthConfig = 
/*isDevMode() && devActive?
{
  identityPoolId: 'sa-east-1:d101009f-3e07-4d2a-b752-dbf60b467fab',
  region: 'sa-east-1',
  userPoolId: 'sa-east-1_E9uhT28sY',
  userPoolWebClientId: '4gr12bvea0md4qfh4cl6h53qg',
  authenticationFlowType : 'USER_PASSWORD_AUTH'
} :*/
{
  identityPoolId: 'us-east-1:00ffde6d-8ca8-4b6b-91ea-b65937068a36',
  region: 'us-east-1',
  userPoolId: 'us-east-1_Ly9N88M8U',
  userPoolWebClientId: '1igurdcr2s0hujhd2k39l6qcae',
  authenticationFlowType : 'USER_SRP_AUTH'
};

export const LINKS_CONFIG: any = {
  share_link: 'https://share.centralcorretor.com.br/',
  ownershare_link: 'https://share.centralcorretor.com.br/'
};

export const STORAGE_CONFIG: StorageConfig = {
  bucket: 'centralcorretor',
  region: 'sa-east-1',
  version: '2006-03-01'
};

export const BUCKETS = {
  1 : "https://content.centralcorretor.com.br"//"https://s3-sa-east-1.amazonaws.com/centralcorretor"
};

export const API = {

    // DASHBOARD
    dashboard: {
      admin : {
        summary :                     new Path('private/admin/summary/',         API_NAME_DEFAULT),      
      }
    }

    // USER
    , user: {
      general: {
        following :                   new Path('private/general/person/following/',       API_NAME_DEFAULT)
      , signup:                       new Path('signup/',                                           API_NAME_DEFAULT, false)
      , signupinvited:                new Path('signupinvited/',                                    API_NAME_DEFAULT, false)
      , creci :                       new Path('private/general/person/verification/creci/',API_NAME_DEFAULT)
      }
    }

    // SITE
    , site : {
      general: {
        list :                       new Path('private/general/site/list/',                     API_NAME_DEFAULT),
        content :                    new Path('private/general/site/content/',                  API_NAME_DEFAULT),
        contentUpdate :              new Path('private/general/site/content/update/',           API_NAME_DEFAULT),
        contentGalleries :           new Path('private/general/site/content/galleries/files/',  API_NAME_DEFAULT),
        post : {
          base :                      new Path('private/general/site/post/',                     API_NAME_DEFAULT),
          list :                      new Path('private/general/site/post/list/',                API_NAME_DEFAULT),
          view :                      new Path('private/general/site/post/view/',                API_NAME_DEFAULT),
          typeList :                  new Path('private/general/site/post/type/list/',           API_NAME_DEFAULT)
        } 
      },
      admin : {
        tempListUpdate :              new Path('private/admin/site/updateindevelopmentfile/',   API_NAME_DEFAULT)
      }
    }
    // CAMPAIGN
    , campaign : {
        general : {
          base :                      new Path('private/admin/campaign/', API_NAME_DEFAULT),
          view :                      new Path('private/admin/campaign/view/', API_NAME_DEFAULT),
          list :                      new Path('private/admin/campaign/list/', API_NAME_DEFAULT),
          authorize :                 new Path('private/admin/campaign/publishauthorize/', API_NAME_DEFAULT),
          reject :                    new Path('private/admin/campaign/publishreject/', API_NAME_DEFAULT),
          publish :                   new Path('private/admin/campaign/publish/', API_NAME_DEFAULT),
          cancel :                    new Path('private/admin/campaign/publishcancel/', API_NAME_DEFAULT),
          unpublish :                 new Path('private/admin/campaign/unpublish/', API_NAME_DEFAULT),
          delete :                    new Path('private/admin/campaign/delete/', API_NAME_DEFAULT),
          undelete :                  new Path('private/admin/campaign/undelete/', API_NAME_DEFAULT)
        },
        manage : {
          base :                      new Path('private/general/campaign/manage/', API_NAME_DEFAULT),
          view :                      new Path('private/general/campaign/manage/view/', API_NAME_DEFAULT),
          list :                      new Path('private/general/campaign/manage/list/', API_NAME_DEFAULT),
          publish :                   new Path('private/general/campaign/manage/publish/', API_NAME_DEFAULT),
          cancel :                    new Path('private/general/campaign/manage/publishcancel/', API_NAME_DEFAULT),
          unpublish :                 new Path('private/general/campaign/manage/unpublish/', API_NAME_DEFAULT),
          delete :                    new Path('private/general/campaign/manage/delete/', API_NAME_DEFAULT),
          undelete :                  new Path('private/general/campaign/manage/undelete/', API_NAME_DEFAULT)
        }
    }


    // PROFILE
    , profile : {
      general: {
        base :                       new Path('private/general/profile/',                API_NAME_DEFAULT),
        signout :                    new Path('private/general/profile/signout/',        API_NAME_DEFAULT),
        password :                   new Path('private/general/profile/password/',       API_NAME_DEFAULT),
        preferences :                new Path('private/general/profile/preferences/',    API_NAME_DEFAULT),
        anonymize :                  new Path('private/general/profile/anonymize/',    API_NAME_DEFAULT) 
      }
    }

    // PERSON
    , person: {
      general : {
          follow :                   new Path('private/general/person/track/',         API_NAME_DEFAULT)
        , views :                    new Path('private/general/person/views/',         API_NAME_DEFAULT)
        , view :                     new Path('private/general/view/person/',          API_NAME_DEFAULT)
        , searchlist :               new Path('private/general/person/searchlist/',    API_NAME_DEFAULT)
        , searchview :               new Path('private/general/person/searchview/',    API_NAME_DEFAULT)
        , companies :                new Path('private/general/person/companies/',     API_NAME_DEFAULT)
        , inviteaccept :             new Path('private/general/person/inviteaccept/',  API_NAME_DEFAULT)
        , heatmap :                  new Path('private/general/person/heatmap/',       API_NAME_DEFAULT)
        , summary :                  new Path('private/general/person/summary/',       API_NAME_DEFAULT)
        , companyuser:               new Path('private/general/person/companyuser/',   API_NAME_DEFAULT)
        , companyview :              new Path('private/general/person/company/view/',  API_NAME_DEFAULT)
        , request: {
            pending :                new Path('private/general/person/request/list/pending/',   API_NAME_DEFAULT),
            view :                   new Path('private/general/person/request/view/',   API_NAME_DEFAULT),
            list :                   new Path('private/general/person/request/list/',   API_NAME_DEFAULT)
        }
        , profile :                  new Path('private/general/profile/view/',           API_NAME_DEFAULT)
        , followers :                new Path('private/general/person/followers/',       API_NAME_DEFAULT)
        , viewers :                  new Path('private/general/person/viewers/list/top', API_NAME_DEFAULT)

        
        
        , authorization : {
            request :                new Path('private/general/person/request/saleauthorization', API_NAME_DEFAULT),
            allow :                  new Path('private/general/person/request/saleauthorization/allow',    API_NAME_DEFAULT),
            reject :                 new Path('private/general/person/request/saleauthorization/reject',   API_NAME_DEFAULT),
            listStatus :             new Path('private/general/person/request/saleauthorization/list/status', API_NAME_DEFAULT),
            listReceived :           new Path('private/general/person/request/saleauthorization/list/received', API_NAME_DEFAULT),
            listGranted :            new Path('private/general/person/request/saleauthorization/list/granted', API_NAME_DEFAULT),
        }
        , material : {
            request :                new Path('private/general/person/request/salematerial/',         API_NAME_DEFAULT),
            allow :                  new Path('private/general/person/request/salematerial/allow',    API_NAME_DEFAULT),
            reject :                 new Path('private/general/person/request/salematerial/reject',   API_NAME_DEFAULT)
        }
        
      },
      admin : {
          list :                     new Path('private/admin/person/list/',              API_NAME_DEFAULT)
        , base :                     new Path('private/admin/person/',                   API_NAME_DEFAULT)
        , edit :                     new Path('private/admin/person/edit/',              API_NAME_DEFAULT)
        , verification:              new Path('private/admin/person/verification/',      API_NAME_DEFAULT)
        , companyuser:               new Path('private/admin/person/companyuser/',       API_NAME_DEFAULT)
        , setuserpassword :          new Path('private/admin/person/maintenence/setuserpassword/',          API_NAME_DEFAULT)
        , updatefollowerscount:      new Path('private/admin/person/maintenence/updatefollowerscount',       API_NAME_DEFAULT)
        , updatepublishedadscount :  new Path('private/admin/person/maintenence/updatepublishedadscount',    API_NAME_DEFAULT)
        , updatesettings :           new Path('private/admin/settings',    API_NAME_DEFAULT)
      }       
    }

    // ADS
    , ad :{
      general : {
          base :                    new Path('private/general/ad/',                      API_NAME_DEFAULT)
        , publish :                 new Path('private/general/ad/publish/',              API_NAME_DEFAULT)
        , pause :                   new Path('private/general/ad/unpublish/',            API_NAME_DEFAULT)
        , cancel :                  new Path('private/general/ad/publishcancel/',        API_NAME_DEFAULT)
        , units :                   new Path('private/general/ad/units/',                API_NAME_DEFAULT) 
        , searchview :              new Path('private/general/ad/searchview/',           API_NAME_DEFAULT)
        , searchlist :              new Path('private/general/ad/searchlist/',           API_NAME_DEFAULT)
        , searchpins :              new Path('private/general/ad/searchpins/',           API_NAME_DEFAULT)
        , searchmap :               new Path('private/general/ad/searchmap/',            API_NAME_DEFAULT)
        , highlights :              new Path('private/general/ad/highlights/',           API_NAME_DEFAULT)
        , follow :                  new Path('private/general/ad/track/',                API_NAME_DEFAULT)
        , edit :                    new Path('private/general/ad/edit/',                 API_NAME_DEFAULT)
        , list :                    new Path('private/general/ad/list/',                 API_NAME_DEFAULT)
        , heatmap :                 new Path('private/general/ad/heatmap/',              API_NAME_DEFAULT)
        , singleshare :             new Path('private/general/ad/singleshare/',          API_NAME_DEFAULT)
        , followers :               new Path('private/general/ad/followers/',            API_NAME_DEFAULT)
        , following :               new Path('private/general/ad/following/',            API_NAME_DEFAULT)
        , restricted : {
            request :               new Path('private/general/ad/restricted/request/',         API_NAME_DEFAULT),
            allow :                 new Path('private/general/ad/restricted/request/allow',    API_NAME_DEFAULT),
            reject :                new Path('private/general/ad/restricted/request/reject',   API_NAME_DEFAULT),
            disallow :              new Path('private/general/ad/restricted/disallow',         API_NAME_DEFAULT),
            list :                  new Path('private/general/ad/restricted/list/',            API_NAME_DEFAULT),
            listAllowed :           new Path('private/general/ad/restricted/list/allowedpersons', API_NAME_DEFAULT),
            listAllowedForPerson :  new Path('private/general/ad/restricted/list/allowedforperson', API_NAME_DEFAULT),
            interested :            new Path('private/general/ad/restricted/interested',       API_NAME_DEFAULT),
        }
      },
      admin : {
          base :                    new Path('private/admin/ad/',                        API_NAME_DEFAULT)
        , units :                   new Path('private/admin/ad/units/',                  API_NAME_DEFAULT)
        , edit :                    new Path('private/admin/ad/edit/',                   API_NAME_DEFAULT)
        , list :                    new Path('private/admin/ad/list/',                   API_NAME_DEFAULT)
        , search:                   new Path('private/admin/ad/search',                  API_NAME_DEFAULT)
        , pause :                   new Path('private/admin/ad/unpublish/',              API_NAME_DEFAULT)
        , publish :                 new Path('private/admin/ad/publish/',                API_NAME_DEFAULT)
        , cancel :                  new Path('private/admin/ad/publishcancel/',          API_NAME_DEFAULT)
        , analyse :                 new Path('private/admin/ad/publishanalyse/',         API_NAME_DEFAULT)
        , reject :                  new Path('private/admin/ad/publishreject/',          API_NAME_DEFAULT)
        , authorize :               new Path('private/admin/ad/publishauthorize/',       API_NAME_DEFAULT)        
        , owner :                   new Path('private/admin/ad/owner/',                  API_NAME_DEFAULT)        
      }
    }

    // CENTRAL PROPRIETARIO
    , ownercentral: {
      filesList :                   new Path('private/general/ownercentral/project/files/list/',          API_NAME_DEFAULT),
      accessPointsList :            new Path('private/general/ownercentral/project/accesspoints/list/',   API_NAME_DEFAULT),
      accessPointsSet :             new Path('private/general/ownercentral/project/accesspoints/',        API_NAME_DEFAULT),
      suppliersList :               new Path('private/general/ownercentral/project/suppliers/list/',      API_NAME_DEFAULT),
      suppliersSet :                new Path('private/general/ownercentral/project/suppliers/',           API_NAME_DEFAULT),
      settingsList :                new Path('private/general/ownercentral/project/settings/list/',       API_NAME_DEFAULT),
      settingsSet :                 new Path('private/general/ownercentral/project/settings/',            API_NAME_DEFAULT),
      memorialList :               new Path('private/general/ownercentral/project/memorial/list/',      API_NAME_DEFAULT),
      memorialSet :                new Path('private/general/ownercentral/project/memorial/',           API_NAME_DEFAULT),
    }

    // INTEGRAÇÕES    
    , integration : {
    }

    // ACCOUNTS
    , account : {
      admin : {
        base:                       new Path('private/admin/accounts/',                API_NAME_DEFAULT)
      }
    }

    // GENERAL
    , general: {
        lead :{
          list:                       new Path('private/general/lead/list',      API_NAME_DEFAULT),
          view:                       new Path('private/general/lead/view',      API_NAME_DEFAULT),
          edit:                       new Path('private/general/lead/edit',      API_NAME_DEFAULT)
        },

        files : {
          preupload:                  new Path('private/general/file/preupload',      API_NAME_DEFAULT)
        , fileBeforeUpload:           new Path('private/general/file/beforeupload/',  API_NAME_DEFAULT)
        , fileAfterUpload:            new Path('private/general/file/afterupload/',   API_NAME_DEFAULT)
        , fileUpdateSort:             new Path('private/general/file/updatesort/',    API_NAME_DEFAULT)
        , fileUpdateTag:              new Path('private/general/file/updatetag/',     API_NAME_DEFAULT)
        , fileDelete:                 new Path('private/general/file/delete/',        API_NAME_DEFAULT)
        , fileUndelete:               new Path('private/general/file/undelete/',      API_NAME_DEFAULT)
        , fileDescription:            new Path('private/general/file/updatedescription/',   API_NAME_DEFAULT)
        
      }
      , event: { 
        view :                        new Path('private/general/view/',               API_NAME_DEFAULT)
      }
      , signin:                       new Path('public/person/signin/',               API_NAME_DEFAULT)
      , leadBuilder:                  new Path('public/lead/builderRequest/',         API_NAME_DEFAULT, false)
      , leadRealestate:               new Path('public/lead/realestaterequest/',      API_NAME_DEFAULT, false)
      , privateSettings:              new Path('private/settings',                    API_NAME_DEFAULT)
      , publicSettings:               HTTP_CONFIG.apiUrl+HTTP_CONFIG.apiStage+'public/settings'
      , terms:                        'https://privacidade.centralcorretor.com.br/terms.html'
      , zipcode:                      new Path('public/city/zipcode/',               API_NAME_DEFAULT)
      , help: {
          report:                     new Path('private/general/help/report',        API_NAME_DEFAULT)
      }
      , indexes:                      new Path('private/general/index/rate/list/',   API_NAME_DEFAULT)
    }    

} ;

